module.exports = __webpack_public_path__ + "static/media/addVerticalBlock.0cdf017b.gif";